// Stripe.js loader for the INLINE Elements checkout (OWNER DIRECTIVE
// 2026-06-12). Card collection happens entirely on /checkout via a mounted
// PaymentElement and stripe.confirmPayment — there is no Stripe-hosted or
// Embedded Checkout, and no redirect to collect payment.
//
// Requires VITE_STRIPE_PUBLISHABLE_KEY at build time (publishable keys are
// safe in the client bundle). When the key is absent, payment is unavailable
// (we never fall back to a redirect — the directive bans it).

import { loadStripe, type Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

export function stripePublishableKey(): string | null {
  const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;
  return typeof key === 'string' && key.startsWith('pk_') ? key : null;
}

export function isStripeAvailable(): boolean {
  return stripePublishableKey() !== null;
}

/** Singleton Stripe instance promise for <Elements stripe={...}>. */
export function getStripe(): Promise<Stripe | null> | null {
  const key = stripePublishableKey();
  if (!key) return null;
  stripePromise ??= loadStripe(key);
  return stripePromise;
}
